/**
 * Texto de versión que muestran los pies de página (login y aplicación).
 * Sale de src/metadata.json, que scripts/sync-version.js alinea con la versión
 * del proyecto (pom de services / package.json). El sufijo (-SNAPSHOT u otro,
 * buildQualifier) nunca se muestra. Si hay buildFix (bugfix de release) se
 * agrega como 4.º número (ej. 2.1.9.1). Metadata vacía -> "".
 */
export const formatVersionLabel = metadata => {
  if (metadata?.buildMajor == null) return ""
  const { buildMajor, buildMinor, buildRevision, buildFix, buildTag } = metadata
  let version = `${buildMajor}.${buildMinor}.${buildRevision}`
  if (buildFix != null && buildFix !== "") version += `.${buildFix}`
  return buildTag ? `v${version} (${buildTag})` : `v${version}`
}
